import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmService } from '../../../shared/confirm-dialog/confirm-dialog.service';
import { StatistikService } from '../../statistik.service';
import { EditForventetTabRequest } from './EditForventetTabRequest';

@Component({
    selector: 'app-statistik-igangvaerende-kunde-dato-modal-ui',
    templateUrl: './statistik-igangvaerende-kunde-dato-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikIgangvaerendeKundeDatoModal {
    selectedsagid: number;
    newForventetTab: number;
    selectedDate: string;

    constructor(
        private activeModal: NgbActiveModal,
        private confirmService: ConfirmService,
        private statistikService: StatistikService
    ) { }

    onDismiss() {
        this.activeModal.dismiss();
    }

    async changeEntry() {
        const answer = await this.confirmService.question('Er du sikker på du gerne vil ændre det forventede tab?', 'Accepter', 'Afbryd');
        if (answer === true) {
            this.editForventetTab();
        } else {
            this.onDismiss();
        }
    }

    editForventetTab() {
        if (this.newForventetTab) {
            const forventetTabRequest: EditForventetTabRequest = {
                sagsId: this.selectedsagid,
                newForventetTab: this.newForventetTab,
                changedDate: this.selectedDate,
            };
                this.statistikService.postEditForventetTab(forventetTabRequest)
                    .subscribe(() => this.activeModal.close());
        } else {
            alert('ForventetTab forbliver uændret, når der står det samme som tidligere.');
        }

    }
}
